import invariant from 'invariant';
import moment from 'moment';
import React from 'react';
import ReactTimeAgo from 'react-time-ago';

type TimeAgoProps = {
  date: string | number | object;
};
const TimeAgo = ({ date }: TimeAgoProps) => {
  // we use invariant because if you don't pass a date, Moment will just return now()
  // causing a bug that can be hard to debug
  invariant(date, '(TimeAgo) you must supply a Date');
  const timestamp = moment(date);
  return <ReactTimeAgo date={timestamp.toDate()} locale="en" />;
};

export default TimeAgo;
